export const nifty50Categories = [
    "Nifty 50",
    "Bank Nifty",
    "Nifty IT",
    "Nifty FMCG",
];

export const totalPortfolioCategories = [
    {
        name: "Growth Portfolio",
        folio: "GP1001",
        value: 1500000,
    },
    {
        name: "Balanced Portfolio",
        folio: "BP2001",
        value: 800000,
    },
    {
        name: "Aggressive Portfolio",
        folio: "AP3001",
        value: 2200000,
    },
];


export const chartData = [
    {
        date: new Date(2024, 11, 1),
        AAPLClose: 175.3,
        GEClose: 110.2,
        close: 130.5,
        high: 178.5,
        low: 170.1,
        volume: 1200000,
    },
    {
        date: new Date(2024, 11, 2),
        AAPLClose: 176.8,
        GEClose: 112.0,
        close: 132.1,
        high: 179.2,
        low: 172.0,
        volume: 1400000,
    },
    {
        date: new Date(2024, 11, 3),
        AAPLClose: 174.5,
        GEClose: 113.5,
        close: 131.0,
        high: 177.5,
        low: 171.3,
        volume: 1350000,
    },
    {
        date: new Date(2024, 11, 4),
        AAPLClose: 177.9,
        GEClose: 115.1,
        close: 134.0,
        high: 180.0,
        low: 173.7,
        volume: 1500000,
    },
    {
        date: new Date(2024, 11, 5),
        AAPLClose: 179.2,
        GEClose: 114.0,
        close: 135.5,
        high: 182.1,
        low: 174.4,
        volume: 1550000,
    },
    {
        date: new Date(2024, 11, 6),
        AAPLClose: 180.0,
        GEClose: 116.3,
        close: 136.8,
        high: 183.2,
        low: 175.5,
        volume: 1600000,
    },
    {
        date: new Date(2024, 11, 7),
        AAPLClose: 181.5,
        GEClose: 117.8,
        close: 138.2,
        high: 184.5,
        low: 176.9,
        volume: 1620000,
    },
    {
        date: new Date(2024, 11, 8),
        AAPLClose: 182.3,
        GEClose: 119.0,
        close: 139.0,
        high: 185.0,
        low: 178.0,
        volume: 1680000,
    },
    {
        date: new Date(2024, 11, 9),
        AAPLClose: 183.1,
        GEClose: 118.4,
        close: 140.5,
        high: 186.3,
        low: 179.2,
        volume: 1700000,
    },
    {
        date: new Date(2024, 11, 10),
        AAPLClose: 184.0,
        GEClose: 120.2,
        close: 141.7,
        high: 187.0,
        low: 180.3,
        volume: 1750000,
    },
];


export const monthData = [
    { month: "Jun'24", portfolio: -10, nifty: -5 },
    { month: "Aug'24", portfolio: 15, nifty: 12 },
    { month: "Oct'24", portfolio: 35, nifty: 30 },
    { month: "Dec'24", portfolio: 5, nifty: 8 },
    { month: "Feb'25", portfolio: -8, nifty: -3 },
    { month: "Apr'25", portfolio: 25, nifty: 15 },
];

export const SipDummyData = [
    {
        Scheme_Name: "Growth Fund A",
        Folio_Number: "F12345678",
        Installments: 12,
        Day_of_month: 15,
        Completed_Installments: 6,
        Amount: 5000,
        Status: "Active",
    },
    {
        Scheme_Name: "Income Fund B",
        Folio_Number: "F87654321",
        Installments: 24,
        Day_of_month: 10,
        Completed_Installments: 18,
        Amount: 10000,
        Status: "Active",
    },
    {
        Scheme_Name: "Balanced Fund C",
        Folio_Number: "F11223344",
        Installments: 6,
        Day_of_month: 5,
        Completed_Installments: 6,
        Amount: 3000,
        Status: "Completed",
    },
];

export const SipCeaseDummyData = [
    {
        Date: "2025-05-01",
        Scheme_Name: "Growth Fund X",
        Folio: "F100001",
        Day_of_Month: 12,
        Completed_Installments: 8,
        Amount: 6000,
        Status: "Ceased",
    },
    {
        Date: "2025-04-15",
        Scheme_Name: "Income Fund Y",
        Folio: "F100002",
        Day_of_Month: 20,
        Completed_Installments: 5,
        Amount: 4000,
        Status: "Ceased",
    },
    {
        Date: "2025-03-10",
        Scheme_Name: "Balanced Fund Z",
        Folio: "F100003",
        Day_of_Month: 5,
        Completed_Installments: 6,
        Amount: 3500,
        Status: "Ceased",
    },
    {
        Date: "2025-02-25",
        Scheme_Name: "Equity Fund A",
        Folio: "F100004",
        Day_of_Month: 8,
        Completed_Installments: 12,
        Amount: 9000,
        Status: "Ceased",
    },
    {
        Date: "2025-01-05",
        Scheme_Name: "Debt Fund B",
        Folio: "F100005",
        Day_of_Month: 15,
        Completed_Installments: 3,
        Amount: 2500,
        Status: "Ceased",
    },
];
